import { BaseApi } from "@/api/base";
import type { Response } from "@/api/client";
import type {
  CheckCallDTO,
  CheckCallInfoDTO,
  CheckCallResponse,
  CreateCheckCallRequest,
} from "@/api/trips/dto/check-call";
import type {
  CreateNewUpdateRequest,
  DismissCheckCallResponse,
  PreviewUpdateRequest,
  PreviewUpdateResponse,
  TripUpdate,
  UpdateMessageIdRequest,
} from "@/api/trips/dto/update";
import type { RateConfirmationActionRequest, RateConfirmationResponse } from "@/api/trips/dto/trip.dto";

export class EventsApi extends BaseApi {
  getCheckCalls(routeId: number): Promise<Response<CheckCallResponse>> {
    return this.client.get("/routes/" + routeId + "/check-calls");
  }

  previewCheckCall(routeId: number): Promise<Response<CheckCallInfoDTO>> {
    return this.client.get("/routes/" + routeId + "/prepare-check-call");
  }

  createCheckCall(routeId: number, data: CreateCheckCallRequest): Promise<Response<CheckCallDTO>> {
    return this.client.post("/routes/" + routeId + "/check-calls", data);
  }

  previewUpdate(routeId: number, data: PreviewUpdateRequest): Promise<Response<PreviewUpdateResponse>> {
    return this.client.post("/routes/" + routeId + "/prepare-update", data);
  }

  createUpdate(routeId: number, data: CreateNewUpdateRequest): Promise<Response<TripUpdate>> {
    return this.client.post("/routes/" + routeId + "/updates", data);
  }

  loadBrokerUpdate(routeId: number, updateId: number): Promise<Response<TripUpdate>> {
    return this.client.get("/routes/" + routeId + "/updates/" + updateId);
  }

  updateMessageId(routeId: number, updateId: number, data: UpdateMessageIdRequest): Promise<Response<TripUpdate>> {
    return this.client.patch("/routes/" + routeId + "/updates/" + updateId, data);
  }

  dismissCheckCall(routeId: number, checkCallId: number): Promise<Response<DismissCheckCallResponse>> {
    return this.client.delete("/routes/" + routeId + "/check-calls/" + checkCallId);
  }

  setRouteAsPlanned(routeId: number): Promise<Response<string>> {
    return this.client.post<string>(`/routes/${routeId}/set-planned`, { routeId });
  }

  setRouteAsCurrent(routeId: number): Promise<Response<string>> {
    return this.client.post<string>("/routes/" + routeId + "/set-current", {
      routeId,
    });
  }

  loadRateConfirmation(routeId: number): Promise<Response<RateConfirmationResponse>> {
    return this.client.get("/routes/" + routeId + "/rate-confirmation");
  }

  downloadRateConfirmation(routeId: number, data: RateConfirmationActionRequest): Promise<Response<Blob>> {
    return this.client.post("/routes/" + routeId + "/rate-confirmation/download", data, {
      responseType: "blob",
    });
  }

  signRateConfirmation(routeId: number, data: RateConfirmationActionRequest): Promise<Response<{ success: boolean }>> {
    return this.client.post("/routes/" + routeId + "/rate-confirmation", data);
  }
}
